import React from 'react'
import { Link } from 'react-router-dom'
import { routes } from 'src/constants/routes'
import { navy } from 'src/layout/colors'
import styled from 'styled-components'

const Main = () => {
  return (
    <>
      <Container100vh>
        <Container>
          <Error>
            <H1>404</H1>
            <p>Stránka nebyla nalezena</p>
            <HomeLink to={routes.main}>Seznam jídelen</HomeLink>
          </Error>
        </Container>
      </Container100vh>
    </>
  )
}

export default Main

const Container100vh = styled.div`
  min-height: calc(100vh - 208.88px);

  display: flex;
  justify-content: center;
  align-items: center;

  background: url('/img/pattern_modry.svg'), ${navy};
  background-attachment: fixed;
  background-position: center;
  background-size: 730px;

  @media (min-width: 366px) {
    min-height: calc(100vh - 219.88px);
  }
`

const Container = styled.div`
  flex: 1;
  padding: 30px 0;
  height: 100%;
`

const Error = styled.div`
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 50px 20px;
  box-shadow: 0rem 0.5rem 2rem rgb(0 0 0 / 20%);
  border-radius: 5px;
  background-color: white;
  text-align: center;

  @media (min-width: 500px) {
    padding: 20px 50px 50px 50px;
    width: 70%;
  }

  @media (min-width: 600px) {
    width: 50%;
  }

  @media (min-width: 900px) {
    width: 30%;
  }

  @media (min-width: 2000px) {
    width: 20%;
  }

  @media (min-width: 3000px) {
    width: 15%;
  }
`

const H1 = styled.h1``

const HomeLink = styled(Link)`
  color: black;
`
